import React from "react";

import {Chip, makeStyles} from "@material-ui/core";

const useBadgeStyles = makeStyles(() => ({
  root: {
    background: 'white',
    color: '#202a38',
    fontSize: '.75rem',
    padding: '0 .375rem',
    height: 'auto',
    lineHeight: '1.25rem',
    maxHeight: '1.3125rem',
    fontWeight: '700!important',
    '& > span': {
      padding: 0
    }
  }
}))

export const Badge = ({value, style}) => {
  const classes = useBadgeStyles()

  return (
    <Chip label={value} className={classes.root} style={style || {}}/>
  )
};

export const BadgeForNew = ({marginLeft=5}) => (
  <Badge
    value={"NEU"}
    style={{color: '#fff', backgroundColor: '#e25443', marginLeft: marginLeft, position: 'relative', top: -7}}
  />
);